const moment = require('moment')
const reloadInfoPin = (appointmentsUpdate, markers, dates, valuesStatus, valuesTypes, valuesCitys, valuesHosts, valuesClients) => {
  const checkAllFilter = (appointment) => {
     const date = dates.length
       ? checkDate(dates, appointment.date)
       : true
     const status = valuesStatus.length
       ? checkFilterId(valuesStatus, appointment.status)
       : true
     const type = valuesTypes.length
       ? checkFilterType(valuesTypes, appointment.type)
       : true
     const city = valuesCitys.length
       ? checkFilterId(valuesCitys, appointment.city.id)
       : true
     const host = valuesHosts.length
       ? checkFilterHost(valuesHosts, (appointment))
       : true
     const client = valuesClients.length
       ? checkFilterId(valuesClients, appointment.real_estate.id)
       : true
     if (date && status && type && city && host && client) {
       return true
     } else {
       return false
     }
     function checkFilterId (valuesFilter, valuetatus) {
       const filter = valuesFilter.filter(function (e) {
         return e.id == valuetatus
       })
       return !!filter.length
     }
   }
   function checkFilterType (valuesFilter, valuetatus) {
    const filter = valuesFilter.filter(function (e) {
      return e.value == valuetatus
    })
    return !!filter.length
  }
   function checkFilterHost (valuesFilter, valuetatus) {
     if (!valuetatus.host) {
       return false
     }
     const filter = valuesFilter.filter(function (e) {
       return e == valuetatus
     })
     return !!filter.length
   }
   function checkDate (valuesDates, value) {
     const m = new moment(value, true)
     return (
       m.isValid() && m.isAfter(valuesDates[0]) && m.isBefore(valuesDates[1])
     )
   }
  const result = {
    create: [],
    update: [],
    delete: [],
  }
  appointmentsUpdate.map((element) => {
     if (markers[element.id]) {
         checkAllFilter(element)
         ? result.update.push(element)
         : result.delete.push(element)
     } else {
       checkAllFilter(element) ? result.create.push(element) : ''
     }
   })
   return result
 }

 exports.reloadInfoPin = reloadInfoPin
